import { Component, Input } from "@angular/core";
import { PonderAuthClient } from "@apiserver-rest/ponder-auth-client";
import { GetRoleResponse, UserRoleType } from "@apiserver-rest/ponder-auth-client-base";
import { AuthSession } from "@ponder-core/auth/auth-session";
import { BusySpinComponent } from "@ponder-shared/components/busy-spin.component";
import { take } from "rxjs";
import { environment } from "../../../../../../environments/environment";
import { AuthService } from "@ponder-core/auth/auth.service";
import { RoleAndPermissions } from "@ponder-core/auth/role-permissions";

@Component({
    selector: "user-type-change",
    imports: [BusySpinComponent],
    templateUrl: "./user-account-type-change.component.html"
})
export class UserAccountTypeChangeComponent {
    @Input({ required: true }) public authSession?: AuthSession;

    public isLoading?: boolean;
    public loadingSuccess: boolean = false;

    public readonly roleTypes = UserRoleType;
    public role?: UserRoleType;
    public roleColor: string = environment.colors.roles.user;

    public constructor(private authService: AuthService) {

    }

    public ngOnChanges(): void {
        this.getUserRole();
    }
    
    private getUserRole(): void {
        if (!this.authSession || (this.isLoading != undefined)) {
            return;
        }

        this.isLoading = true;
        
        this.authService.getRoleAndPermissions().then((roleAndPermissions?: RoleAndPermissions) => {
            if (roleAndPermissions) {
                this.role = (roleAndPermissions.role as string) as UserRoleType;

                switch (this.role) {
                    case UserRoleType.UserPlus:
                        this.roleColor = environment.colors.roles.userPlus;
                        break;

                    case UserRoleType.Moderator:
                        this.roleColor = environment.colors.roles.moderator;
                        break;

                    case UserRoleType.Administrator:
                        this.roleColor = environment.colors.roles.administrator;
                        break;

                    default:
                        this.roleColor = environment.colors.roles.user;
                        break;
                }

                this.loadingSuccess = (this.role != undefined);
            }
        }).finally(() => this.isLoading = false);
    }
    
    public canUpgradeAccount(): boolean {
        return (this.role == UserRoleType.User);
    }

    public canDowngradeAccount(): boolean {
        return (this.role == UserRoleType.UserPlus);
    }
}